"use strict";
/**
 * @file Created on 27.05.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var NotificationDoc_1 = require("../NotificationDoc");

var NChangedProduct_1 = require("./NChangedProduct");
/**
 * @author Tomas Leity
 */


var NChangedProductDTO =
/*#__PURE__*/
function (_NotificationDoc_1$No) {
  _inherits(NChangedProductDTO, _NotificationDoc_1$No);

  /**
   * @param products
   */
  function NChangedProductDTO(products) {
    var _this;

    _classCallCheck(this, NChangedProductDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NChangedProductDTO).call(this));
    _this.products = products;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(NChangedProductDTO, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new NChangedProductDTO(mat.products);
    }
  }]);

  return NChangedProductDTO;
}(NotificationDoc_1.NotificationDoc);

exports.NChangedProductDTO = NChangedProductDTO;

NChangedProductDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NChangedProductDTO.name);
  return {
    products: builder.listOf(builder.obj('products', NChangedProduct_1.NChangedProduct.schema, function (mat) {
      return NChangedProduct_1.NChangedProduct.fromDataDict(mat);
    }))
  };
}();